
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import NavigationList from './navigation-list'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "navigationlist"
    }}>{`NavigationList`}</h1>
    <hr />
    <h2 {...{
      "id": "navigation-list"
    }}>{`Navigation list`}</h2>
    <Playground __position={1} __code={'<NavigationList type=\"section\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationList
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationList type='section' mdxType="NavigationList" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={NavigationList} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;